import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import AnalyticsDashboardLayer from "../../components/Trading/AnalyticsDashboardLayer";
import Breadcrumb from "../../components/Breadcrumb";

const ReportsAnalyticsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Reports & Analytics" />
      <AnalyticsDashboardLayer />
    </MasterLayout>
  );
};

export default ReportsAnalyticsPage;
